import { useMemo } from 'preact/hooks';
import style from './NumberInput.css';
import { _className } from '../../../utils/classname.utils';
import { renderIf } from '../../../utils/render.utils';

const RE_DIGIT = new RegExp(/^\d+$/);

export default function NumberInput({
  helperText = '',
  className = '',
  hasError = false,
  disabled = false,
  length = 6,
  value = '',
  masked = false,
  onChange = () => {},
}) {
  const valueItems = useMemo(() => {
    const valueArray = value.split('');
    const items = [];

    for (let i = 0; i < length; i++) {
      const char = valueArray[i];

      if (RE_DIGIT.test(char)) {
        items.push(char);
      } else {
        items.push('');
      }
    }

    return items;
  }, [value, length]);

  const focusToNextInput = target => {
    const nextElementSibling = target.nextElementSibling;

    if (nextElementSibling) {
      nextElementSibling.focus();
    }
  };

  const inputOnChange = (e, idx) => {
    const { target } = e;
    let targetValue = target.value.trim();
    const isTargetValueDigit = RE_DIGIT.test(targetValue);

    if (!isTargetValueDigit && targetValue !== '') {
      return;
    }

    targetValue = isTargetValueDigit ? targetValue : ' ';

    const targetValueLength = targetValue.length;

    if (targetValueLength === 1) {
      const newValue =
        value.substring(0, idx) + targetValue + value.substring(idx + 1);

      onChange(newValue);

      if (!isTargetValueDigit) {
        return;
      }

      const nextElementSibling = target.nextElementSibling;

      if (nextElementSibling) {
        nextElementSibling.focus();
      }

      if (!isTargetValueDigit) {
        return;
      }

      focusToNextInput(target);
    } else if (targetValueLength === valueLength) {
      onChange(targetValue);

      target.blur();
    }
  };

  const inputOnFocus = e => {
    const { target } = e;

    target.setSelectionRange(0, target.value.length);
  };

  const inputOnKeyDown = e => {
    const { target } = e;
    const targetValue = target.value;
    target.setSelectionRange(0, targetValue.length);

    if (e.key !== 'Backspace' || target.value !== '') {
      return;
    }
    const previousElementSibling = target.previousElementSibling;
    if (previousElementSibling) {
      previousElementSibling.focus();
    }
  };

  return (
    <div
      className={`${className} ${style['number-input']} ${_className(
        hasError,
        style['has-error'],
      )} ${_className(disabled, style['disabled'])}`}
    >
      <div className={style['number-input-inner']}>
        {valueItems.map((digit, idx) => (
          <input
            key={idx}
            type={masked ? 'password' : 'text'}
            inputMode="numeric"
            pattern="\d{1}"
            className="otp-input"
            maxLength="1"
            value={digit}
            disabled={disabled}
            onInput={e => inputOnChange(e, idx)}
            onKeyDown={inputOnKeyDown}
            onFocus={inputOnFocus}
          />
        ))}
      </div>
      {renderIf(
        helperText,
        <span className={`${style['input-helper']}`}>{helperText}</span>,
      )}
    </div>
  );
}
